import React from 'react';
import { TwoOptionSelect, Input } from '@blueprintnyc/bpnyc-common';
import ColorInput from 'components/ColorInput';
import LinkPicker from 'components/LinkOmniPicker/LinkPicker';
import ImageUpload from 'components/ImageUpload';
import config from 'config';

const ButtonItemOptions = ({
	buttonProps,
	index,
	event,
	handleSetButtonProps,
	setOmniPicker,
	handlePickOmniItem,
}) => {
	const { onPress = {}, buttonColor = '#AAAAAA', textColor = '#FFFFFF', size, position, text } =
		(buttonProps && buttonProps[index]) || {};
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<div>
			<div>
				<h4 className="admin-form-item-label">Button {index + 1} Text</h4>
				<Input value={text} onChange={text => handleSetButtonProps('text', index, text)} />
			</div>

			<h4 className="admin-form-item-label">Button {index + 1} Link</h4>
			<LinkPicker
				onClick={() =>
					setOmniPicker({ open: true, mediaPicker: false, from: 'link', index, onPress })
				}
				onPress={onPress}
				placeholderStr={'Select Link Target'}
				onConfirm={() => handlePickOmniItem({}, index)}
			/>
			<div className="ColorPickers">
				<div>
					<h4 className="admin-form-item-label">Background Color</h4>
					<ColorInput
						color={buttonColor}
						onChange={hex => handleSetButtonProps('buttonColor', index, hex)}
						eventID={event.id}
					/>
				</div>
				<div>
					<h4 className="admin-form-item-label">Text Color</h4>

					<ColorInput
						color={textColor}
						onChange={hex => handleSetButtonProps('textColor', index, hex)}
						eventID={event.id}
					/>
				</div>
			</div>
			<div className="same-row">
				<div>
					<h4 className="admin-form-item-label">Upload an Icon</h4>
					<ImageUpload
						endpoint={signedUrlEndpoint}
						value={buttonProps[index]?.source?.src || ''}
						onChange={source => handleSetButtonProps('source', index, source)}
						imageObj={true}
					/>
				</div>
				<div>
					<h4 className="admin-form-item-label">Text Size</h4>
					<TwoOptionSelect
						selected={size !== 'large'}
						onChange={val => handleSetButtonProps('size', index, val ? 'default' : 'large')}
						yesLabel="Default"
						noLabel="Large"
					/>
					<h4 className="admin-form-item-label">Icon Position (optional)</h4>
					<TwoOptionSelect
						selected={position !== 'right'}
						onChange={val => handleSetButtonProps('position', index, val ? 'left' : 'right')}
						yesLabel="Left"
						noLabel="Right"
					/>
				</div>
			</div>
		</div>
	);
};

export default ButtonItemOptions;
